// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./../../img/deck-dark.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./../../img/deck.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 * SPDX-FileCopyrightText: 2020 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */.icon-deck{background-image:url(${___CSS_LOADER_URL_REPLACEMENT_0___})}body.dark .icon-deck{background-image:url(${___CSS_LOADER_URL_REPLACEMENT_1___})}`, "",{"version":3,"sources":["webpack://./src/css/dashboard.scss"],"names":[],"mappings":"AAAA;;;EAAA,CAIA,WACC,wDAAA,CAGD,qBACC,wDAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
